import classNames from 'classnames';
import './HelpTitle.css';

export const HelpTitle = ({ className, ...props }: React.ComponentProps<'div'>) => {
  return <div className={classNames(className, 'settings-help-title')} {...props} />;
};
